<template>
	<validation-provider
			:name="'AdminSelectGroupCode-' + contentKey + '-' + inputItemKey"
			:rules="getValidationRules(contents[contentKey].inputItems[inputItemKey].rules)"
			v-slot="{ errors }">
		<v-autocomplete
				v-model="$store.state.admin.input[inputItemKey]"
				:items="arrayObject($_admnSlctUsrGrpCd_stateAdminGroups())"
				item-text="key"
				item-value="key"
				placeholder="Group Code"
				@change="$_admnSlctUsrGrpCd_setAdminState()"
				:error-messages="errors" />
	</validation-provider>
</template>

<script>
	export default {
		name: 'AdminSelectUserGroupCode',
		props: {
			contentKey: String,
			inputItemKey: String,
			contents: Object,
			inits: Object
		},
		data () {
			return {
				defaultGroup_: {
					all: {
						name: 'All Users',
						description: 'Default Group'
					}
				}
			}
		},
		computed: {
			$_admnSlctUsrGrpCd_stateAdminGroups() {
				const self_ = this;
				return () => {
					return self_.getAdminState('groups')
				}
			}
		},
		created() {
			const self_ = this;
			self_.$_admnSlctUsrGrpCd_getGroups()
		},
		methods: {
			$_admnSlctUsrGrpCd_getGroups() {
				const self_ = this;

				let groups_ = self_.getAdminState('groups')

				if(!self_.isEmpty(groups_)) { return }

				groups_ = self_.defaultGroup_;

				Promise.resolve().then(() => {
					return self_.getFirestoreCollection('groups', {}, 0)
				}).then(result => {
					Object.keys(result).forEach(key => {
						groups_[key] = result[key]
					})

					self_.setAdminState('groups', groups_)
				})
			},
			$_admnSlctUsrGrpCd_setAdminState() {
				const self_ = this;

				let input_ = self_.getAdminState('input')
				const code_ = input_[self_.inputItemKey]

				if(self_.contentKey == 'updateGroup') {
					input_.name = self_.adminGetGroup(code_, 'name')
					input_.description = self_.adminGetGroup(code_, 'description')
				} else {
					input_.userGroupName = self_.adminGetGroup(code_, 'name')
				}
				self_.setAdminState('input', input_)
			}
		}
	}
</script>

<style scoped>
</style>
